import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import "../../commissions/components/CommissionCreationForm.css";
import DatePicker from "react-datepicker";
import Modal from "react-responsive-modal";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
//import CommissionCreationCorrectiveEvent from "./CommissionCreationCorrectiveEvent";

import { create_dando,dandoUpdate, select_case } from "../redux/actions";

import { HeaderDivider } from "../../common/components/HeaderDivider";
import { Button } from "../../common/components/Button";
import { CommissionHeaders } from "../../common/components/SectionHeader";
import { ErrorMessage } from "../../common/components/ErrorMessage";
import { FaTimes } from "react-icons/fa";
import "../../components/Purchases/Disclosure.css";
import Disclosure from "./Disclosure";
import DisclosureModal from "./DisclosureModal";
import { ConvertTimeZoneValue } from "../../util";
import 'bootstrap/dist/css/bootstrap.min.css';


const FormButton = styled(Button)`
	height: 25px;
`;

const ButtonHolder = styled.div`
	margin-top: 10px;
`;

const RightSideButton = styled(Button)`
	marginright: 15px;
`;

const LeftSideButton = styled(Button)`
	float: right;
`;

class DandOCreationForm extends Component {
	constructor() {
		super();
		this.state = {
			company_name: "",
			ticker: "",
			notes: "",
			risk_assessment_date: null,
			openModal: false,
			isUpdateForm: false,
			loader:false,
			selected_case : {},
			isPrePop : false,
			last_trading_date: null

		};
	}

	componentDidMount() {
		let dandoId = this.props.match.params.dandoId;
		
		if (dandoId) {
			if(dandoId!=='0'){
				this.setState({ isUpdateForm: true });
				this.props.dandoUpdate(dandoId);
			}
		}  
		let today = this.props.firmSettings.lastTradingDate? new Date(this.props.firmSettings.lastTradingDate): new Date();
		this.setState({...this.state,company_name:this.props.new_dando_request.company_name,ticker:this.props.new_dando_request.ticker,risk_assessment_date:today,notes:this.props.new_dando_request.notes?this.props.new_dando_request.notes:''});
		let caseId = this.props.match.params.caseId;
		
		if (caseId) {
			if(caseId > 0) {
				this.props.select_case(caseId);
				this.setState({ isPrePop: true });
			}
		} 
		
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps && nextProps.UpdateDandOResult) {
		
			var riskAssessmentDate = this.props.firmSettings.lastTradingDate? new Date(this.props.firmSettings.lastTradingDate): new Date();	

			this.setState({ 
				company_name: nextProps.UpdateDandOResult.companyName,
				ticker:nextProps.UpdateDandOResult.ticker,
				notes:nextProps.UpdateDandOResult.notes,
				risk_assessment_date: riskAssessmentDate,      
				last_trading_date: nextProps.UpdateDandOResult.lastTradingDate,      
			});
		
			this.setState({loader:global.loader})
	 
		}
		
		if (nextProps && nextProps.selected_case) {
				
				this.setState({loader:global.loader})
				let today = this.props.firmSettings.lastTradingDate? new Date(this.props.firmSettings.lastTradingDate): new Date();	
				
				this.setState({...this.state,ticker: nextProps.selected_case.ticker, company_name: nextProps.selected_case.fillingName, risk_assessment_date : today });	
		} 
	}

	change_company_name = event => {
		this.setState({ company_name: event.target.value });
	};

	change_notes = event => {
		this.setState({ notes: event.target.value });
	};

	change_ticker = event => {
		this.setState({ ticker: event.target.value });
	};

	change_risk_assessment_date = date => {
		this.setState({ risk_assessment_date: date });
	};


	submit_form = () => {
		 this.setState({loader:true})

		const data = {
			symbol: this.state.ticker,
			companyName: this.state.company_name,
			riskAssessmentDate: ConvertTimeZoneValue(this.state.risk_assessment_date),
			notes: this.state.notes,
		};

		this.props.create_dando(data,this.props.firmSettings.subscription);
	};

	onCloseModal = () => {
		this.setState({ openModal: false });
	};

	onOpenModel = () => {
		this.setState({ openModal: true });
	};

	

	render() {
		let errorMessage = null;
		
		if (this.props.new_dando_error) {
			errorMessage = (
				<ErrorMessage>{this.props.new_dando_error}</ErrorMessage>
				);
		}

	const dando_disabled = this.state.company_name === "" ||
		!!!this.state.ticker ||
		!!!this.state.risk_assessment_date

	return (
		<React.Fragment>
		<div>
			<div>{errorMessage}</div>     
			<CommissionHeaders>
			Securities Litigation Risk Report
			</CommissionHeaders>
			<HeaderDivider />
			<div className="fullwidth" id={"commission-report-basic-data"}>
			<div className="name-width">
				<div className={"commission-input-label"}>
					<p />
				Company Name
				</div>
				<input
				value={this.state.company_name}
				readOnly={this.state.isUpdateForm||this.state.isPrePop}
				className={"commission-input fullwidth"}
				onChange={this.change_company_name}
				placeholder={"Company Name"}
				/>
			</div>
			<div className="ticker-width">
				<div className={"commission-input-label"}><p />Ticker</div>
				<input
				value={this.state.ticker}
				readOnly={this.state.isUpdateForm||this.state.isPrePop}
				className={"commission-input fullwidth"}
				onChange={this.change_ticker}
				placeholder={"Ticker"}
				/>
			</div>
			<div className="startdt-width">
				<div className={"commission-input-label"}>*Risk Assessment Date</div>
				<DatePicker
				selected={this.state.risk_assessment_date}
				onChange={date => this.change_risk_assessment_date(date)}
				placeholderText={"Select date"}
				maxDate={moment()}
				dropdownMode={"select"}
				className={"commission-input fullwidth"}
				showYearDropdown
				readOnly={this.state.isUpdateForm}
				/>
			</div>
			
			</div>
			<div className="m-t-20">
			<div className={"commission-input-label"}>Notes</div>
			<textarea
				className={"commission-input"}
				onChange={this.change_notes}
				cols={40}
				rows={3}
				placeholder={"Notes"}
				value={this.state.notes}
			/>
			</div>
		</div>

		<div id={"commission-button-holder"}>
			<FormButton
			height={"25px"}
			disabled={dando_disabled}
			onClick={this.onOpenModel}
			tabIndex="-1"
			>
			License SAR Risk Report
			</FormButton>
			<Link to={this.state.isUpdateForm?"/dandos/"+this.props.match.params.dandoId:(this.state.isPrePop?"/":"/dandos")}>
			<FormButton>Cancel</FormButton>
			</Link>
			<br />
			

			
		</div>
		<div class="disclosure-text">
			*Near-real time securities litigation risk assessment is estimated based on stock price performance as of the close of trading on the date preceding the Risk Assessment Date.
		</div>

		{/* //  Privileged and Confidential model start */}
		<Modal
			open={this.state.openModal}
			onClose={this.onCloseModal}
			focusTrapped={true}
			styles={{ modal: { height: "90%", overflow: "auto" } }}
		>
			<div className="ModalWindow modaladd">
			<FaTimes className="closeicon" onClick={this.onCloseModal} />
			<div className="modalHeading"></div>
			<div className="NavDivider"></div>
			<Disclosure />
			<div className="NavDivider"></div>
			<div>
				<DisclosureModal createFormState={this.state} />
			</div>
			<div>
				<div className="NavDivider"></div>
				<ButtonHolder>
				<RightSideButton
					onClick={() => this.submit_form()}
					hoverBorderColor="darkgreen"
					tabIndex="-1"
				>
					Confirm
				</RightSideButton>
				<LeftSideButton
					onClick={this.onCloseModal}
					hoverBorderColor="red"
					tabIndex="-1"
				>
					Decline
				</LeftSideButton>
				</ButtonHolder>
			</div>
			</div>
		</Modal>
		{/* //  Privileged and Confidential model end */}
		<Modal
			open={this.state.loader}
			onClose={this.onCloseModal}
			focusTrapped={true}
			styles={{ modal: { marginTop:(window.outerHeight/2)-80 } }}
		>
		<div className="loader"></div>
		</Modal>
		</React.Fragment>
	);
	}
}

const mapStateToProps = state => {

	return {
		dando_request: state.dandos.dando_request,
		new_dando_error: state.dandos.new_dando_error,
		new_dando_request: state.dandos.new_dando_request,
		firmSettings:state.firmSettings,
		UpdateDandOResult: state.dandos.UpdateDandOResult,
		selected_case: state.dandos.selected_case,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		create_dando: (data,subscription) => dispatch(create_dando(data,subscription)),
		dandoUpdate: resultDandO => dispatch(dandoUpdate(resultDandO)),
		select_case: caseId => dispatch(select_case(caseId)),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(DandOCreationForm));



// WEBPACK FOOTER //
// ./src/dandos/components/DandOCreationForm.js